import * as React from 'react'
import { FC, useMemo } from 'react'
import { IProviderProps } from '@user/components/Filters'
import {
  IOption,
  optionDependencyToArray,
} from '@user/components/Filters/typings/IOption'
import {
  selectAllSalesTeams,
  selectAllSalesTeamsUsers,
} from '@user/store/salesTeam'
import { useSelector } from 'react-redux/es/hooks/useSelector'
import { useGetEligibleUsersForSalesTeams } from '@user/store/users/hooks/useGetEligibleUsersForSalesTeams'
import { useCheckAdminPermissions } from '@user/store/authorization/permissions/useCheckPermissions'
import { SettingsAdminPermOps } from '@user/store/authorization'

export const AssigneeProvider: FC<IProviderProps> = ({ render, dependsOn }) => {
  const salesTeamOptions = optionDependencyToArray(dependsOn)
  const allSalesTeams = useSelector(selectAllSalesTeams)

  const { isFetching: loading } = useGetEligibleUsersForSalesTeams(
    salesTeamOptions.length > 0
      ? salesTeamOptions.map((x) => Number(x.value))
      : allSalesTeams.map((x) => x.id),
  )

  const [showAdminUsers] = useCheckAdminPermissions(SettingsAdminPermOps)

  const owners = useSelector(selectAllSalesTeamsUsers)

  const options = useMemo(() => {
    const options: IOption[] = owners
      .filter(
        (user) => user.isActive && (!showAdminUsers ? !user.isAdmin : true),
      )
      .map((owner) => ({
        value: owner.id,
        label: owner.name,
        parentId: owner.salesTeamId,
      }))
    options.sort((a, b) => a.label.localeCompare(b.label))

    options.unshift({
      value: '00000000-0000-0000-0000-000000000000',
      label: 'Unassigned',
    })
    return options
  }, [owners, showAdminUsers])

  const enableGroup = !salesTeamOptions?.length
  return <>{render(options, loading, enableGroup)}</>
}
AssigneeProvider.displayName = 'AssigneeProvider'
